import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Badge, Card, Checkbox, Column, Divider, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './ProposalItemCard.module.scss';
export const GetProposalItemCardTID = (parentTestId)=>getTestIds(parentTestId);
export const ProposalItemCard = (param)=>{
    let { item, checked, disabled, onChange, testId, className } = param;
    var _item_badges;
    const { ProposalItemCardTID } = useMemo(()=>GetProposalItemCardTID(testId), [
        testId
    ]);
    const handleClick = ()=>{
        if (!disabled) onChange();
    };
    const handleKeyDown = (e)=>{
        if (disabled) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onChange();
        }
    };
    return /*#__PURE__*/ _jsx(Card, {
        bi: {
            name: 'agent_drafting_proposal_card'
        },
        testId: testId,
        skin: "white",
        borderSkin: "default",
        borderRadius: "l",
        shadow: "none",
        className: cn(styles.card, {
            [styles.disabled]: disabled
        }, className),
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        role: "button",
        tabIndex: disabled ? -1 : 0,
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 12,
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 8,
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            gap: 6,
                            alignItems: "center",
                            wrap: true,
                            className: styles.nameRow,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    weight: "normal",
                                    className: styles.name,
                                    testId: ProposalItemCardTID.Name(),
                                    children: item.name
                                }),
                                (_item_badges = item.badges) === null || _item_badges === void 0 ? void 0 : _item_badges.map((badge, idx)=>/*#__PURE__*/ _jsx(Badge, {
                                        rounded: true,
                                        outlined: true,
                                        testId: ProposalItemCardTID.Badge(idx),
                                        children: badge
                                    }, idx))
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Checkbox, {
                            checked: checked,
                            onChange: onChange,
                            className: styles.checkbox,
                            testId: ProposalItemCardTID.Checkbox(),
                            bi: {
                                name: 'agent_drafting_proposal_card_checkbox'
                            }
                        })
                    ]
                }),
                item.groups.map((group, groupIdx)=>/*#__PURE__*/ _jsxs(Column, {
                        gap: 4,
                        testId: ProposalItemCardTID.Group(groupIdx),
                        children: [
                            groupIdx > 0 && /*#__PURE__*/ _jsx(Divider, {}),
                            group.headerLabel != null ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph1",
                                        testId: ProposalItemCardTID.GroupHeaderLabel(groupIdx),
                                        children: group.headerLabel
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph3",
                                        skin: "secondary",
                                        testId: ProposalItemCardTID.GroupTitle(groupIdx),
                                        children: group.title
                                    })
                                ]
                            }) : /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                testId: ProposalItemCardTID.GroupTitle(groupIdx),
                                children: group.title
                            }),
                            group.entries.map((entry, entryIdx)=>/*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph3",
                                    testId: ProposalItemCardTID.Entry(groupIdx, entryIdx),
                                    children: entry.label
                                }, entryIdx))
                        ]
                    }, groupIdx))
            ]
        })
    });
};
